import { Button, Divider, Dropdown, Popover, Space } from "antd"
import { useMemo, useState } from "react"
import styles from "./index.module.scss"
import Iconfont from '@utils/Iconfont';

const TipContent = () => {
    const items = [{
        title: "点击图片查看大图",
        content: "查看图片细节，确认交付质量",
    }, {
        title: "选择通过/不通过",
        content: "可以留下标注信息，能更好地理解需求",
    }, {
        title: "一组商品都审核完成后，点击【提交反馈】",
        content: "点击提交审核后，将进入后续流程",
    }]

    return (
        <div className={styles.TipContent}>
            <div className={styles.Title}>审核流程</div>
            <Divider />
            <div className={styles.ItemContainer}>
            {items.map((item, index) => (
                <div key={index} className={styles.Item}>
                    <span>{item.title}</span>
                    <span>{item.content}</span>
                </div>
            ))}
            </div>
        </div>
    )
}

const DeliveryDetailActions = ({
    selectRowKeys,
    isMultiSelect,
    onDownload,
    onMultiDownload,
    onMultiFeedback,
    onMultiSelect,
    onSelectAll,
}) => {

    if (!isMultiSelect) return (
        <Space size={12}>
            <Popover placement="bottomRight" arrow={false} content={<TipContent />}>
                <Button key="tip" className={styles.btn} icon={<Iconfont type="icon-info" style={{fontSize:16}} />}>操作说明</Button>
            </Popover>
            <Button key="multi" className={styles.btn} icon={<Iconfont type="icon-batch" style={{fontSize:16}} />} onClick={() => onMultiSelect(true)}>批量操作</Button>
            <Button className={styles.btn} type="primary" icon={<Iconfont type="icon-download" style={{fontSize:16}} />} onClick={e => onDownload()} >下载当前批次</Button>
        </Space>
    )
    else return (
        <Space size={10}>
            <span style={{fontSize:14, lineHeight:20, color: "rgba(0, 0, 0, 0.5)"}}>已选商品：{selectRowKeys.length}组</span>
            <Space.Compact>
                <Button key="download" className={styles.btn} icon={<Iconfont type="icon-download" style={{fontSize:16}} />} onClick={onMultiDownload}>下载</Button>
                <Button key="feedback" className={styles.btn} icon={<Iconfont type="icon-comment" style={{fontSize:16}} />} onClick={onMultiFeedback}>提交反馈</Button>
                <Button key="all" className={styles.btn} onClick={onSelectAll}>全选</Button>
                <Button key="cancel" className={styles.btn} onClick={() => onMultiSelect(false)}>取消</Button>
            </Space.Compact>
        </Space>
    )
}

export default DeliveryDetailActions